module.exports = __webpack_public_path__ + "static/media/waysnap-small-white.e8bebea6.png";